export const SHORT_TRANSITION_TIMEOUT = 666;
